/**
 * @constant Статические данные для BildCheckList
 */
export const BILD_CHECK_LIST = {
  checkedMsg: 'Проверенные',
  titleMsg: 'Проверка бильдредакторов',
  uncheckedMsg: 'Непроверенные'
}
